import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AddModeratorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"add_moderator"}/>
}
